import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M11.971 5.25a.75.75 0 0 1 .672.364l2.793 4.656a4.75 4.75 0 0 1 3.411 7.517l3.683 3.683a.75.75 0 1 1-1.06 1.06l-3.683-3.683a4.75 4.75 0 1 1-4.015-8.437L12.06 7.557l-3.39 6.778a.75.75 0 0 1-1.366-.057l-1.34-3.35-3.279 7.377a.75.75 0 0 1-1.37-.61l4-9a.75.75 0 0 1 1.381.026l1.38 3.45 3.253-6.506a.75.75 0 0 1 .642-.414ZM15 11.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function r(c, d) {
  return e(), l("svg", o, [...a]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
